import Grid from "@mui/material/Unstable_Grid2";
import React, { useEffect } from "react";
import { Box, Link } from "@mui/material";
import Modules from "../CustomisationSettings/Modules/Modules";
import Templates from "../CustomisationSettings/Templates/Templates";
import MainSettingMenu from "../MainSettingMenu/MainSettingMenu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate } from "react-router-dom";
import PersonalSetting from "../GeneralSettings/PersonalSettings/PersonalSetting";
import Appearance from "../GeneralSettings/Appearance/Appearance";
import EmailSettings from "../GeneralSettings/EmailSettings/EmailSettings";
// import Currencies from "../MainSettingMenu/Currencies";
import Currencies from "../OrganisationSettings/Currencies/Currencies";
import Taxation from "../OrganisationSettings/Taxation/Taxation";
import OrganisationDetails from "../OrganisationSettings/OrganisationDetails/OrganisationDetails";

function SettingModulesForm() {
  const navigate = useNavigate();
  const [activePage, setActivePage] = React.useState("personalSetting");
  const [section, setSection] = React.useState("");

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  useEffect(() => {
    const windowURL = window.location.search;
    const params = new URLSearchParams(windowURL);

    let section = params.get("section");
    let page = params.get("page");

    setSection(section ?? "");
    setActivePage(page ?? "");
  }, []);

  return (
    <Box className="newSettingWrapper h-100">
      <Grid xs={12}>
        <h3 className="pageTitle mb-7 ">
          <Link
            onClick={() => {
              navigate("/EmployerSettings");
            }}
          >
            <ChevronLeftIcon />
          </Link>
          Settings
        </h3>
      </Grid>
      <Grid container>
        <Grid xs sx={{ maxWidth: "250px" }}>
          {section.length > 0 ? (
            <MainSettingMenu
              section={section}
              attrName={setActivePage}
              value={activePage}
              value_update={updateMasterState}
            />
          ) : null}
        </Grid>
        <Grid xs>
          {activePage === "modules" ? <Modules /> : null}
          {activePage === "templates" ? <Templates /> : null}
          {activePage === "personalSetting" ? <PersonalSetting /> : null}
          {activePage === "emailSettings" ? <EmailSettings /> : null}
          {activePage === "appearance" ? <Appearance /> : null}
          {activePage === "Currencies" ? <Currencies /> : null}
          {activePage === "Modules" ? <Modules /> : null}
          {/* {activePage === "OrganisationDetails" ? (
            <OrganisationDetails />
          ) : null} */}
          {activePage === "Taxation" ? <Taxation /> : null}
          {activePage === "CompanyDetails" ? <OrganisationDetails /> : null}
        </Grid>
      </Grid>
    </Box>
  );
}

export default SettingModulesForm;
